import React from 'react';

import { currentWinner, isDrawn, useMatchScoreDraft } from './scoring-match-draft';
import ScoringMatchForm from './scoring-match-form';
import ScoringMatchSides from './scoring-match-sides';
import type { MatchItem, ScoringSystem } from './scoring-types';

interface Props {
  match: MatchItem;
  token: string;
  canSubmit: boolean;
  scoring?: ScoringSystem;
  cancelLabel?: string;
  onSaved: () => void;
  onCancel: () => void;
}

export const ScoringMatchEntry: React.FC<Props> = ({
  match,
  token,
  canSubmit,
  scoring,
  cancelLabel = 'Wróć do meczów',
  onSaved,
  onCancel,
}) => {
  const draft = useMatchScoreDraft(match, token, onSaved);
  const winner = canSubmit ? draft.winner : currentWinner(match);

  function handleCancel(): void {
    draft.reset();
    onCancel();
  }

  return (
    <div className="scoring-modal__entry" data-testid={`scoring-modal-entry-${match.id}`}>
      <ScoringMatchSides
        match={match}
        sets={draft.walkover === null ? draft.sets : []}
        winner={winner}
        scoring={scoring}
        drawn={canSubmit ? draft.drawn : isDrawn(match)}
        numbered
      />

      {canSubmit ? (
        <ScoringMatchForm
          match={match}
          draft={draft}
          cancelLabel={cancelLabel}
          onCancel={handleCancel}
        />
      ) : (
        <p className="scoring-modal__empty">Kolejka zamknięta — wyniku nie da się już zmienić.</p>
      )}
    </div>
  );
};

export default ScoringMatchEntry;
